import React, { FC, useContext } from "react";
import { ModalContext } from "context/modal";
import { ZipCodeContext } from "context/zipCode";
import st from "./deliverToZip.module.scss";
import { InternalLink } from "@pepdirect/ui/InternalLink";
import Image from "next/image";

interface DeliverToZipProps {
  isSubscription: boolean;
}

export const DeliverToZip: FC<DeliverToZipProps> = ({ isSubscription }) => {
  const { open } = useContext(ModalContext);
  const { zipCode } = useContext(ZipCodeContext);
  const handleClick = () => open("ZIPCODE_MODAL");
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      open("ZIPCODE_MODAL");
    }
  };

  return (
    <div className={st.wrapper}>
      <div className={st.zipNote}>
        <span className={st.note}>Note:</span> This item may not be able to be
        shipped to all zip codes and will be determined at checkout. Prices
        subject to change without notice.{" "}
        {isSubscription && (
          <span
            className={st.subscriptionText}
            data-testid="deliver-to-subscription"
          >
            By selecting &quot;Subscribe&quot;, you agree to PantryShop by
            PepsiCo <InternalLink href="/terms">Terms of Service</InternalLink>{" "}
            and{" "}
            <InternalLink href="/terms#subscription-terms">
              Subscription Terms
            </InternalLink>
            .
          </span>
        )}
      </div>
      <div className={st.deliverImage}>
        <Image
          src="/assets/deliver-to-image.svg"
          alt="deliver pin"
          width="20"
          height="30"
        />
        {zipCode ? (
          <span className={st.deliver}>
            Delivering to{" "}
            <span
              className={st.zip}
              onClick={handleClick}
              onKeyPress={handleKeyPress}
              role="button"
              tabIndex={0}
              data-testid="deliver-to-zipcode"
            >
              {zipCode}
            </span>
          </span>
        ) : (
          <span
            className={`${st.deliver} ${st.zip}`}
            onClick={handleClick}
            onKeyPress={handleKeyPress}
            role="button"
            tabIndex={0}
            data-testid="deliver-to-no-zipcode"
          >
            Deliver to
          </span>
        )}
      </div>
    </div>
  );
};
